import {getReportParams, report} from "app/middleware/report";

export function dwhRepPurchaseForSoldier(repName, idNumber, soldierNumber, soldierName, transactionId) {
  let reportParams = getReportParams();
  reportParams.area = 'IDF';
  reportParams.subArea = 'IDFSale';
  reportParams.channel = 'WebsiteIDF';
  reportParams.actionType = 'IDF Rep Sale';
  reportParams.subscriber = soldierNumber;
  reportParams.customerName = soldierName;
  reportParams.idNumber = idNumber;
  reportParams.status = 'Completed';
  reportParams.messageText = `נציג ${repName} ביצע רכישה עבור חייל מספר ${soldierNumber}`;
  reportParams.param1 = repName;
  reportParams.param2 = transactionId;
  report(reportParams);
}

export function dwhRepPurchaseNiudForSoldier(repName, idNumber, soldierNumber, soldierName, transactionId) {
  let reportParams = getReportParams();
  reportParams.area = 'IDF';
  reportParams.subArea = 'IDFSale';
  reportParams.channel = 'WebsiteIDF';
  reportParams.actionType = 'IDF Rep Sale Niud';
  reportParams.subscriber = soldierNumber;
  reportParams.customerName = soldierName;
  reportParams.idNumber = idNumber;
  reportParams.status = 'Completed';
  reportParams.messageText = `נציג ${repName} ביצע רכישה וניוד עבור חייל מספר ${soldierNumber}`;
  reportParams.param1 = repName;
  reportParams.param2 = transactionId;
  reportParams.param3 = soldierNumber;
  report(reportParams);
}

export function dwhRepUpgradeForSoldier(repName, idNumber, soldierNumber, soldierName, transactionId) {
  let reportParams = getReportParams();
  reportParams.area = 'IDF';
  reportParams.subArea = 'IDFSale';
  reportParams.channel = 'WebsiteIDF';
  reportParams.actionType = 'IDF Rep Upgrade';
  reportParams.subscriber = soldierNumber;
  reportParams.customerName = soldierName;
  reportParams.idNumber = idNumber;
  reportParams.status = 'Completed';
  reportParams.messageText = `נציג ${repName} ביצע שדרוג מכשיר עבור חייל מספר ${soldierNumber}`;
  reportParams.param1 = repName;
  reportParams.param2 = transactionId;
  report(reportParams);
}
